<template>
  <div class="base-modal" v-if="popNoticeDetail">
      <header id="header-pop">
        <h1>공지사항</h1>
        <button type="button" class="close" @click="close">닫기</button>
      </header>
      <section id="wrap">
        <div class="notice-Detail">
          <div>
            <i>일반</i>
            <em>2020.12.18</em>
            <p>공지사항 타이틀 공지사항 타이틀 두줄 공지사항 타이틀 두줄일 경우</p>
          </div>
          <article>
            12월 ‘교원SMART체험’조직별 체험담당 공지사항 내용입니다. 공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다.
            공지사항 내용입니다.공지사항 내용입니다. 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다.
            12월 ‘교원SMART체험’조직별 체험담당 공지사항 내용입니다. 공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다.
            공지사항 내용입니다.공지사항 내용입니다. 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다.
            12월 ‘교원SMART체험’조직별 체험담당 공지사항 내용입니다. 공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다.
            공지사항 내용입니다.공지사항 내용입니다. 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다.
            12월 ‘교원SMART체험’조직별 체험담당 공지사항 내용입니다. 공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다.
            공지사항 내용입니다.공지사항 내용입니다. 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다.
            12월 ‘교원SMART체험’조직별 체험담당 공지사항 내용입니다. 공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다. 공지사항 내용입니다.공지사항 내용입니다.
            공지사항 내용입니다.공지사항 내용입니다. 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다. 공지사항 내용입니다.
            공지사항 내용입니다.
          </article>

          <p class="file">
            <button type="button" v-on:click="showPopAttachView">이미지 이미지 이벤트 대상 상품 목록.doc</button>
            <button type="button" v-on:click="showPopAttachView">이미지 이미지 이벤트 대상 상품 목록.doc</button>
          </p>
        </div>
      </section>
      <div class="btnWrap">
        <button type="button" class="black" @click="close">목록</button>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    popNoticeDetail: {
      type: Boolean,
      require: true,
      default: false
    },
    detail: {
      type: Object,
      default: function() {
        return { id: "", title: "" };
      }
    }
  },
  methods: {
    close: function() {
      this.$emit("self-show", false);
    },
    showPopAttachView: function() {
      this.$emit("child-attach-show", true, this.detail);
    }
  },
  beforeUpdate: function() {
    if (
      (this.detail.id == "" || typeof this.detail.id == "undefined") &&
      this.$route.hash == "#pop-notice-detail"
    ) {
      this.$router.back();
    }
  }
};
</script>
